module.exports = __webpack_public_path__ + "img/email.d46e7643.png";